<div class="page-head-section">
    <p>Records</p>
  </div>
  
  <div class="flex-selector">

    <div class="drop-area">
        <p-dropdown
          placeholder="Select Type"
          [options]="recordType"
          [(ngModel)]="selectedType"
        >
        </p-dropdown>
      </div>
  
      <div class="drop-area">
        <p-dropdown
          placeholder="Select Type"
          [options]="recordCategory"
          [(ngModel)]="selectedCategory"
        >
        </p-dropdown>
      </div>
  
      <div class="drop-area">
        <p-dropdown
          placeholder="Select Type"
          [options]="recordSubCategory"
          [(ngModel)]="selectedSubCategory"
        >
        </p-dropdown>
      </div>
  
    <button
      (click)="getResults()"
      [disabled]="selectedType === ''"
      class="search-button"
    >
      Search
    </button>
  </div>
  
  <div class="result-area">
    <div *ngIf="ResultData.length === 0" class="no-result">
      No record found !
    </div>
  
    <div *ngIf="ResultData.length > 0" class="ui-g">
      <div   *ngFor="let data of ResultData" class="ui-g-4 ui-lg-4 ui-md-6 ui-sm-12">
        <div
          (click)="toLink(global.basePathImage + data.link)"
          class="result-card"
        >
          <p>
            {{data?.name}}  {{data?.type}} - {{data?.category}} : {{ data?.subCategory }}
          </p>
        </div>
      </div>
    </div>
  </div>
  